import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Skeleton — animated placeholder bar for loading states.
 * Used in tables, cards, and forms while data resolves.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
